<div class="marbetes">
  <div class="form-container card">
    <h5 class="title">Impresión de marbetes</h5>

    <form (ngSubmit)="onSubmit()">
      <div class="input-box">
        <label for="policy" class="required-field">Póliza</label>
        <input
          type="text"
          [maxlength]= 15
          id="policy"
          name="policy"
          class="input-field"
          placeholder="No. de póliza"
          (keypress)="onlyNumbers($event)"
          (change)="onlyNumbers($event)"
          (input)="onlyNumbers($event)"
          [(ngModel)]="policy"
        />
      </div>

      <div class="action-buttons">
        <button
          type="submit"
          class="button btn-m-new"
          [disabled]="!policy || policy.length < 12"
        >
          Buscar
        </button>
        <button
          type="button"
          class="button btn-s-new limpiar"
          (click)="onClearForm()"
        >
          Limpiar
        </button>
      </div>
    </form>
  </div>

  @if(responseData?.length){
  <div class="info card">
    <div class="input-box">
      <label for="ref-from">Referencia desde</label>
      <input
        (input)="onFilterUnit()"
        (keypress)="onFilterUnit()"
        type="number"
        id="ref-from"
        name="ref-from"
        class="input-field refDesde"
        [(ngModel)]="unitFrom"
        />
      </div>

      <div class="input-box">
        <label for="ref-to">Referencia hasta</label>
        <input
        (input)="onFilterUnit()"
        (keypress)="onFilterUnit()"
        type="number"
        id="ref-to"
        name="ref-to"
        class="input-field refHasta"
        [(ngModel)]="unitTo"
      />
    </div>

    <div class="input-box">
      <label for="effectiveness">Efectividad</label>
      <div class="date-input">
        <input
          type="text"
          id="effectiveness"
          class="input-field efectiva disabled"
          appCustomDatePicker
          disabled
          [(ngModel)]="effectiveDate"
        />
      </div>
    </div>

    <div class="input-box">
      <label for="valid-from">Vigencia desde</label>
      <div class="date-input">
        <input
          type="text"
          id="valid-from"
          class="input-field vigDesde disabled"
          [(ngModel)]="validFrom"
          name="validFrom"
          appCustomDatePicker
          disabled
          [(ngModel)]="validFrom"
        />
      </div>
    </div>

    <div class="input-box">
      <label for="valid-to">Vigencia hasta</label>
      <div class="date-input">
        <input
          type="text"
          id="valid-to"
          class="input-field vigHasta disabled"
          [(ngModel)]="validTo"
          name="validTo"
          appCustomDatePicker
          disabled
          [(ngModel)]="validTo"
        />
      </div>
    </div>
    @if(!isDataHealth){
      <div class="input-box">
        <label for="download-all">Acción</label>
        <div class="date-input">
          <button
            (click)="getAllMarbetes()"
            type="button"
            class="btn-m-new"
            id="download-all"
          >
            Descargar todos
          </button>
        </div>
      </div>
    }
  </div>
  } @if(!!tableConfig){
  <div class="table">
    <app-insurance-table
      [data]="filteredData!"
      [config]="tableConfig!"
      [mensajeNoData]="noDataMessage"
      [error]="errorStatus"
      [itemsPerPage]="4"
      (actionClick)="onDownloadCarnet($event)"
    ></app-insurance-table>
  </div>
  }
</div>

<!-- Notificacion -->

<app-notification
  [show]="showNotification"
  [type]="notificationType"
  [title]="notificationTitle"
  [message]="notificationMessage"
></app-notification>
